<template>
  <v-app>
    <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container>

        <v-row justify="center">

          <v-col cols="12" lg="8" md="8" sm="12">

            <v-card color="#393E46">
              <v-card-title>
                Contraseña
              </v-card-title>
              <v-card-text>
                <v-alert
                    :value="alerteditar"
                    color="green"
                    dark
                    dismissible
                    border="top"
                    transition="scale-transition"
                >
                  Se password se cambio con exito.
                </v-alert>
                <v-row>
                  <v-col cols="12" sm="12" lg="12" md="12">
                    <v-text-field
                        prepend-icon="fas fa-key" v-model="password" placeholder="Password" type="password"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" lg="12" md="12">
                    <v-text-field
                        prepend-icon="fas fa-key" v-model="cpassword" placeholder="Confirmar Password" type="password"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-row>
                  <v-col>
                <v-btn color="primary" @click="cambiaPassword">
                    Cambiar Contraseña
                </v-btn></v-col>
                <v-col>
                  <v-btn color="green">
                    <router-link color="white" style="text-decoration: none; color: white" :to="{ name: 'perfil'}">Datos</router-link>
                  </v-btn>
                </v-col>
                  <v-col>
                    <v-btn color="blue">
                      <router-link color="white" style="text-decoration: none; color: white" :to="{ name: 'fotoperfil'}">Foto</router-link>
                    </v-btn>
                  </v-col>
                <v-col>
                  <v-btn color="brown">
                    <router-link color="white" style="text-decoration: none; color: white" :to="{ name: 'direccion'}">Direccion</router-link>
                  </v-btn>
                </v-col></v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>

<script>
import cabecera from "@/components/general/cabecera";
import piepagina from "@/components/general/piepagina";
import {mapGetters} from "vuex";
import moment from "moment";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  name: 'password',
  title: 'QRs | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    cabecera,
    piepagina,
  },
  data: () => ({
    paises: {},
    overlay:false,
    token:'',
    date: new Date().toISOString().substr(0, 10),
    provincias:[],
    alerteditar: false,
    ciudades:[],
    distritos:[],
    tiposdocumento: [],
    password:'',
    cpassword: '',
    getips:'',
    menu1:false,
  }),
  mounted() {
    this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
  },
  methods:{

    formatDatee(value) {
      return moment(value).locale('es-pe').format("DD MMMM YYYY")
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    formatDate (date) {
      return moment(date).locale('es-pe').format("DD-MM-YYYY");
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    cambiaPassword(){
      if(this.password === this.cpassword){
        var user = firebase.auth().currentUser
        user.updatePassword(this.password).then(()=>{
          this.alerteditar = true
          this.password = ""
          this.cpassword = ""
        })
      }
    }
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario"
    })
  }
}
</script>
